import React, { useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import type { UseGreeningAnalysisResult } from '../../hooks/useGreeningAnalysis';
import { GREENING_AGENT_LABEL } from './constants';
import { GreeningAnalysisPanel } from './GreeningAnalysisPanel';
import { analysisSpeechSegments } from './voice/analysisSpeech';
import { GreeningListenPanel } from './voice/GreeningListenPanel';
import { greeningTalkButtonSx } from './voice/GreeningVoiceControls';

interface Props {
  legislationId: number | null | undefined;
  greening: UseGreeningAnalysisResult;
  subject?: string;
}

/** Aba AI Greening — card de análise (chat via FAB flutuante). Avatares ficam só na modal de voz. */
export function GreeningTabPanel({ legislationId, greening, subject }: Props) {
  const [listening, setListening] = useState(false);
  const [reading, setReading] = useState<{ section: string; ratio: number } | null>(null);
  const speech = analysisSpeechSegments(greening.analysis);

  if (!legislationId) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
        Norma sem identificador de legislação — análise do agente {GREENING_AGENT_LABEL} indisponível para este registro.
      </Typography>
    );
  }

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
        <Button
          variant="contained"
          disableElevation
          disabled={speech.length === 0}
          onClick={() => setListening(true)}
          sx={{ ...greeningTalkButtonSx, borderRadius: 999, textTransform: 'none', fontWeight: 700 }}
        >
          Ouvir análise
        </Button>
      </Box>
      <GreeningListenPanel
        open={listening}
        segments={speech}
        subject={subject}
        onReading={setReading}
        onClose={() => {
          setReading(null);
          setListening(false);
        }}
      />
      <GreeningAnalysisPanel
        analysis={greening.analysis}
        loading={greening.analysisLoading}
        compactTop
        readingSection={reading?.section}
        readingRatio={reading?.ratio ?? 0}
      />
    </Box>
  );
}

export default GreeningTabPanel;
